/**
 * @name store/modules/config.js
 * @module app
 *
 * @description
 * The typescript store.
 *
 * @project spotgig4web
 * @author Ryunosuke Oguri on 2017/02/06
 * Copyright © 2017年 Axis-motion. All rights reserved.
 */

/*jshint esversion: 6 */

import config from '../../../api/config';
import * as types from './mutation-types';

const state = {
  settings: {
    service: {
      spotgig: {
        domain: null,
        endpoint: {},
        help: {
          endpoint: null,
          request_endpoint: null,
          change_schedule_endpoint: null,
          email_rejected: null,
          missing_verification_code: null,
        },
        chrome: {
          ios: null,
          android: null,
        },
        email: {
          assistant_support: null,
        },
        tel: {
          assistant_support: null,
        },
        version: {
          app: null,
        }
      },
      pmassist: {
        domain: null,
        endpoint: {},
        help: {
          endpoint: null,
          request_endpoint: null,
          change_schedule_endpoint: null,
        },
        chrome: {
          ios: null,
          android: null,
        },
        email: {
          assistant_support: null,
        },
        tel: {
          assistant_support: null,
        },
        version: {
          app: null,
        }
      }
    },
    company: {
      tel: {
        assistant_support: null,
      }
    },
  },
  installPmAppUrl: null,
  success: {},
  error: [],
};

const getters = {
  settings: state => state.settings,
  installPmAppUrl: state => state.installPmAppUrl,
  helpCenterEndpoint: state => state.settings.service.spotgig.help.endpoint || null,
  helpCenterRequestEndpoint: state => state.settings.service.spotgig.help.request_endpoint || null,
  aboutSpotgigEndpoint: state => state.settings.service.spotgig.endpoint.web || null,
  changeScheduleEndpoint: state => state.settings.service.spotgig.help.change_schedule_endpoint || null,
  cancelPolicyEndpoint: state => state.settings.service.spotgig.help.cancel_policy || null,
  myDomain: state => state.settings.service.spotgig.domain || null,
  versionWebApp: state => state.settings.service.spotgig.version.app || null,
  assistantSupportTelNumber: state => state.settings.company.tel.assistant_support,
  spotgigAssistantSupportTelNumber: state => state.settings.service.spotgig.tel.assistant_support,
  pmassistAssistantSupportTelNumber: state => state.settings.service.pmassist.tel.assistant_support,
};

const actions = {
  getConfig ({ commit }, params) {
   return new Promise((resolve, reject) => {
     config.getAll(params, response => {
       if ( response.data.error === null ) {
         commit(types.RECEIVE_CONFIG, response.data.content);
         commit(types.SET_INSTALL_PM_APP_URL);
         resolve(response);
       } else {
         commit(types.REQUEST_ERROR, response.data.error);
         reject(response.data.error);
       }
     }).catch((error) => {
       commit(types.REQUEST_ERROR, error);
       reject(error);
     });
   });
  },
};

const mutations = {
  [types.RECEIVE_CONFIG] (state, payload) {
    state.settings = payload;
  },
  [types.SET_INSTALL_PM_APP_URL] (state) {
    //iOS
    if ( navigator.userAgent.indexOf('iPhone') > 0 || navigator.userAgent.indexOf('iPad') > 0 || navigator.userAgent.indexOf('iPod') > 0 ) {
      state.installPmAppUrl = state.settings.service.pmassist.install.ios;
    // Android
    } else if( navigator.userAgent.indexOf('Android') > 0 ) {
      state.installPmAppUrl = state.settings.service.pmassist.install.android;
    } else {
      state.installPmAppUrl = state.settings.service.pmassist.install.ios;
    }
  },
  [types.REQUEST_SUCCESS] (state, messages) {
    state.success = { code: 200, messages: messages };
  },
  [types.REQUEST_ERROR] (state, payload) {
    state.error = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
